module.exports = __webpack_public_path__ + "img/excel-download.977028cc.svg";